module.exports = {"610981100":"城关镇","610981101":"棕溪镇","610981102":"关口镇","610981103":"蜀河镇","610981104":"双河镇","610981105":"小河镇","610981106":"赵湾镇","610981107":"麻坪镇","610981108":"甘溪镇","610981109":"白柳镇","610981110":"吕河镇","610981111":"神河镇","610981112":"铜钱关镇","610981113":"段家河镇","610981114":"仙河镇","610981115":"金寨镇","610981116":"桐木镇","610981117":"构元镇","610981118":"石门镇","610981119":"红军镇","610981120":"仁河口镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610981.json
// module id = 3021
// module chunks = 0